import { ChevronLeft, ChevronRight, KeyboardArrowDown } from '@mui/icons-material';
import { Box, Button, CircularProgress, Dialog, DialogContent, Grid, IconButton, Menu, MenuItem, Paper, Popper, Stack, Typography } from '@mui/material';
import { TimePicker } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import dayjs from 'dayjs';
import { useEffect, useMemo, useRef, useState } from 'react';
import CommonDialog from '../../../../common/CommonDialog';
import { useGetAppointmentsBySlot, useGetAvailableDates, useGetSlotsWithDisabled } from '../../../../services/core/settings/settings.hooks';
import { isTimeWithinBusinessHours } from '../../../../utility/helpers/commonFunction';

// --- SVG Icons ---
const UserIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
        <path
            d="M10.0026 3.33334C10.8867 3.33334 11.7345 3.68453 12.3596 4.30965C12.9847 4.93478 13.3359 5.78262 13.3359 6.66668C13.3359 7.55073 12.9847 8.39858 12.3596 9.0237C11.7345 9.64882 10.8867 10 10.0026 10C9.11855 10 8.2707 9.64882 7.64558 9.0237C7.02046 8.39858 6.66927 7.55073 6.66927 6.66668C6.66927 5.78262 7.02046 4.93478 7.64558 4.30965C8.2707 3.68453 9.11855 3.33334 10.0026 3.33334ZM10.0026 11.6667C13.6859 11.6667 16.6693 13.1583 16.6693 15V16.6667H3.33594V15C3.33594 13.1583 6.31927 11.6667 10.0026 11.6667Z"
            fill="#006CDD"
        />
    </svg>
);

const ClockIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
        <path
            d="M9.99739 16.6667C11.7655 16.6667 13.4612 15.9643 14.7114 14.714C15.9617 13.4638 16.6641 11.7681 16.6641 9.99999C16.6641 8.23188 15.9617 6.53619 14.7114 5.28594C13.4612 4.0357 11.7655 3.33332 9.99739 3.33332C8.22928 3.33332 6.53359 4.0357 5.28335 5.28594C4.03311 6.53619 3.33073 8.23188 3.33073 9.99999C3.33073 11.7681 4.03311 13.4638 5.28335 14.714C6.53359 15.9643 8.22928 16.6667 9.99739 16.6667ZM9.99739 1.66666C11.0917 1.66666 12.1754 1.8822 13.1864 2.30099C14.1975 2.71978 15.1161 3.33361 15.8899 4.10743C16.6638 4.88125 17.2776 5.79991 17.6964 6.81096C18.1152 7.82201 18.3307 8.90564 18.3307 9.99999C18.3307 12.2101 17.4528 14.3297 15.8899 15.8925C14.3271 17.4553 12.2075 18.3333 9.99739 18.3333C5.38906 18.3333 1.66406 14.5833 1.66406 9.99999C1.66406 7.78985 2.54204 5.67024 4.10484 4.10743C5.66764 2.54463 7.78726 1.66666 9.99739 1.66666ZM10.4141 5.83332V10.2083L14.1641 12.4333L13.5391 13.4583L9.16406 10.8333V5.83332H10.4141Z"
            fill="#006CDD"
        />
    </svg>
);

const CarIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
        <path
            d="M17.8031 9.13601L16.2769 7.60001L14.9231 4.66669C14.8068 4.46187 14.6438 4.29295 14.4498 4.17618C14.2558 4.05941 14.0373 3.99875 13.8154 4.00002H6.18462C5.96268 3.99875 5.74418 4.05941 5.55017 4.17618C5.35616 4.29295 5.19317 4.46187 5.07692 4.66669L3.72308 7.60001L2.19692 9.13601C2.13475 9.19848 2.08517 9.27419 2.05128 9.35839C2.01739 9.4426 1.99993 9.53348 2 9.62534V15.3333C2 15.5101 2.06484 15.6797 2.18024 15.8047C2.29565 15.9298 2.45217 16 2.61538 16H5.07692C5.32308 16 5.69231 15.7333 5.69231 15.4667V14.6667H14.3077V15.3333C14.3077 15.6 14.5538 16 14.8 16H17.3846C17.5478 16 17.7044 15.9298 17.8198 15.8047C17.9352 15.6797 18 15.5101 18 15.3333V9.62534C18.0001 9.53348 17.9826 9.4426 17.9487 9.35839C17.9148 9.27419 17.8652 9.19848 17.8031 9.13601ZM6.30769 5.33335H13.6923L14.9231 8.00001H5.07692L6.30769 5.33335ZM6.92308 11.4667C6.92308 11.7333 6.55385 12 6.30769 12H3.72308C3.47692 12 3.23077 11.6 3.23077 11.3333V9.86668C3.35385 9.46668 3.6 9.20001 3.96923 9.33334L6.43077 9.86668C6.67692 9.86668 6.92308 10.2667 6.92308 10.5333V11.4667ZM16.7692 11.3333C16.7692 11.6 16.5231 12 16.2769 12H13.6923C13.4462 12 13.0769 11.7333 13.0769 11.4667V10.5333C13.0769 10.2667 13.3231 9.86668 13.5692 9.86668L16.0308 9.33334C16.4 9.20001 16.6462 9.46668 16.7692 9.86668V11.3333Z"
            fill="#006CDD"
        />
    </svg>
);

const ServiceIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
        <path
            d="M12.2511 5.25001C12.0984 5.40578 12.0129 5.61521 12.0129 5.83334C12.0129 6.05147 12.0984 6.2609 12.2511 6.41667L13.5844 7.75001C13.7402 7.9027 13.9496 7.98822 14.1678 7.98822C14.3859 7.98822 14.5953 7.9027 14.7511 7.75001L17.8928 4.60834C18.3118 5.53433 18.4387 6.56603 18.2565 7.56596C18.0743 8.56589 17.5917 9.48654 16.873 10.2052C16.1543 10.9239 15.2337 11.4065 14.2337 11.5887C13.2338 11.7709 12.2021 11.644 11.2761 11.225L5.51777 16.9833C5.18625 17.3149 4.73661 17.5011 4.26777 17.5011C3.79893 17.5011 3.34929 17.3149 3.01777 16.9833C2.68625 16.6518 2.5 16.2022 2.5 15.7333C2.5 15.2645 2.68625 14.8149 3.01777 14.4833L8.7761 8.72501C8.35707 7.79902 8.2302 6.76731 8.41239 5.76738C8.59458 4.76746 9.07717 3.8468 9.79587 3.12811C10.5146 2.40941 11.4352 1.92681 12.4351 1.74462C13.4351 1.56243 14.4668 1.68931 15.3928 2.10834L12.2594 5.24167L12.2511 5.25001Z"
            fill="#006CDD"
        />
    </svg>
);

// --- Styling ---
const styles = {
    dialogPaper: (isSidePanelOpen) => ({
        width: isSidePanelOpen ? '760px' : '460px',
        maxWidth: isSidePanelOpen ? '760px' : '460px',
        borderRadius: '12px',
        boxShadow: '0px 4px 24px 0px rgba(0, 0, 0, 0.12)',
        overflow: 'hidden',
        overflowX: 'hidden',
        backgroundColor: '#FFF',
        transition: 'width 0.4s cubic-bezier(0.4, 0, 0.2, 1), max-width 0.4s cubic-bezier(0.4, 0, 0.2, 1)',
    }),
    dialogContent: {
        p: 0,
        overflowX: 'hidden',
        '&.MuiDialogContent-root': { padding: 0 },
    },
    container: {
        display: 'flex',
        width: '100%',
        height: '100%',
    },
    leftSection: (isSidePanelOpen) => ({
        display: 'flex',
        flexDirection: 'column',
        width: '460px',
        minWidth: '460px',
        flexShrink: 0,
        borderRight: isSidePanelOpen ? '1px solid #E0E0E0' : 'none',
    }),
    upperRow: {
        display: 'flex',
        width: '100%',
        p: '12px 0 0 0',
        flex: 1,
    },
    calendarSection: {
        width: '339px',
        minWidth: '339px',
        borderRadius: '0!important',
        borderRight: '1px solid #E0E0E0!important',
        p: '0 12px',
        backgroundColor: '#FFF',
        flexShrink: 0,
    },
    calendarHeader: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        mb: 2,
    },
    navButton: {
        width: '38px',
        height: '38px',
        color: '#212121',
        '&:hover': { backgroundColor: 'rgba(0, 108, 221, 0.08)', color: '#006CDD' },
    },
    headerTextGroup: {
        display: 'flex',
        alignItems: 'center',
        gap: 0.5,
    },
    monthText: {
        fontSize: '16px',
        fontWeight: 400,
        color: '#212121',
        cursor: 'pointer',
    },
    yearArrowBtn: {
        width: '20px',
        height: '20px',
        color: '#006CDD',
        padding: 0,
        ml: 0.5,
    },
    menu: {
        maxHeight: '300px',
        mt: 1,
    },
    menuItem: {
        fontSize: '14px',
        py: 1,
    },
    weekDayContainer: {
        mb: 0.5,
    },
    weekDayText: {
        textAlign: 'center',
        fontSize: '12px',
        fontWeight: 400,
        color: '#212121',
        lineHeight: '16px',
        py: 0,
    },
    dayGridItem: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        p: 0,
        height: '44px',
        width: '44px',
    },
    dayButton: (disabled, selected, isToday, isOff) => ({
        width: '44px',
        height: '44px',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        cursor: disabled ? 'not-allowed' : 'pointer',
        borderRadius: '50px !important',
        backgroundColor: selected ? '#007AFF' : 'transparent',
        border: selected ? '1px solid #0066E1' : 'none',
        boxShadow: selected ? '0 2px 2px 0 rgba(0, 122, 255, 0.25)' : 'none',
        color: disabled ? '#BDBDBD' : selected ? '#FFF' : isToday ? '#007AFF' : '#212121',
        fontSize: '16px',
        fontWeight: selected ? 600 : isToday ? 600 : 400,
        lineHeight: '20px',
        opacity: disabled ? 0.5 : 1,
        position: 'relative',
        '&:hover': {
            backgroundColor: !disabled && !selected ? 'rgba(0, 122, 255, 0.1)' : undefined,
        },
        transition: 'all 0.2s ease',
    }),
    dayDot: (selected) => ({
        width: '4px',
        height: '4px',
        borderRadius: '50%',
        backgroundColor: selected ? '#FFF' : '#007AFF',
        position: 'absolute',
        bottom: '6px',
        left: '50%',
        transform: 'translateX(-50%)',
    }),
    timeListContainer: {
        flex: 1,
        p: '0 12px',
        backgroundColor: '#FFF',
        width: 'max-content',
        maxHeight: '318px',
        overflowY: 'auto',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-end',
        '&::-webkit-scrollbar': {
            width: '4px',
        },
        '&::-webkit-scrollbar-track': {
            backgroundColor: '#F5F5F5',
        },
        '&::-webkit-scrollbar-thumb': {
            backgroundColor: '#BDBDBD',
            borderRadius: '2px',
            '&:hover': {
                backgroundColor: '#9E9E9E',
            },
        },
    },
    timeStack: {
        flex: 1,
        width: '100%',
        alignItems: 'flex-end',
    },
    timeSlotButton: (selected, isManuallyDisabled) => ({
        width: '87px',
        height: '33px',
        py: '8px!important',
        px: '12px!important',
        borderRadius: selected ? '50px' : '100px',
        fontSize: '14px',
        fontWeight: 400,
        lineHeight: '120%',
        letterSpacing: '0.15px',
        textTransform: 'none',
        backgroundColor: selected ? '#007AFF' : isManuallyDisabled ? '#FFF' : '#FFF',
        color: selected ? '#FFF' : isManuallyDisabled ? '#D32F2F' : '#212121',
        border: selected ? '1px solid #0066E1' : isManuallyDisabled ? '1px solid #D32F2F' : '1px solid #DCDCDC',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        '&:hover': {
            backgroundColor: selected ? '#0066E1' : isManuallyDisabled ? '#FDEDED' : 'rgba(0, 122, 255, 0.08)',
            border: selected ? '1px solid #0066E1' : isManuallyDisabled ? '1px solid #D32F2F' : '1px solid #007AFF',
            color: selected ? '#FFF' : isManuallyDisabled ? '#D32F2F' : undefined,
        },
        boxShadow: selected ? '0 2px 2px 0 rgba(0, 122, 255, 0.25)' : '0 2px 3px 0 rgba(0, 0, 0, 0.06)',
        transition: 'all 0.2s ease',
    }),
    popperModifiers: [
        {
            name: 'offset',
            options: { offset: [0, 24] },
        },
    ],
    tooltipContainer: { position: 'relative', display: 'flex', alignItems: 'center' },
    tooltipConnector: (tooltipColor) => ({
        position: 'absolute',
        left: -24,
        width: '24px',
        height: '1px',
        backgroundColor: tooltipColor,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
    }),
    tooltipDot: (tooltipColor) => ({
        width: '5px',
        height: '5px',
        borderRadius: '50%',
        backgroundColor: tooltipColor,
    }),
    tooltipPaper: {
        p: '0 12px',
        borderRadius: '26px',
        display: 'flex',
        alignItems: 'center',
        gap: '6px',
        height: '37px',
        backgroundColor: '#FFF',
        boxShadow: '0 2px 3px 0 rgba(0, 0, 0, 0.06)',
        cursor: 'pointer',
        border: '1px solid #DCDCDC',
    },
    tooltipCountBox: {
        width: '20px',
        height: '20px',
        borderRadius: '50%',
        backgroundColor: '#007AFF',
        color: '#FFF',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        fontSize: '14px',
        fontWeight: 600,
        lineHeight: '130%',
        letterSpacing: '0.15px',
    },
    tooltipText: {
        fontSize: '16px',
        fontWeight: 400,
        color: '#212121',
        lineHeight: '130%',
        letterSpacing: '0.15px',
    },
    footerContainer: {
        borderRadius: '0',
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
    },
    timeRow: {
        borderTop: '1px solid #E0E0E0!important',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-end',
        gap: 2,
        p: '8px 12px',
    },
    timeLabel: {
        fontSize: 14,
        fontWeight: 500,
        minWidth: '60px',
        textAlign: 'right',
    },
    timePickerSx: {
        '& .MuiInputBase-root': {
            height: '45px',
            borderRadius: '8px',
            border: '1px solid #006CDD',
            paddingRight: '0px',
            width: '100px',
            fontSize: '14px',
            backgroundColor: '#fff',
            boxShadow: '0 2px 3px 0 rgba(0, 0, 0, 0.06)',
        },
        '& .MuiOutlinedInput-notchedOutline': {
            border: 'none',
        },
        '& .MuiInputBase-input': {
            padding: '8px',
            textAlign: 'center',
            fontSize: '14px',
            fontWeight: 400,
            color: '#212121',
        },
        '& .MuiInputAdornment-root': {
            display: 'none',
        },
    },
    buttonsRow: {
        display: 'flex',
        justifyContent: 'flex-end',
        gap: 1,
        borderTop: '1px solid #E0E0E0!important',
        p: '12px',
    },
    sidePanel: (isSidePanelOpen) => ({
        width: isSidePanelOpen ? '300px' : '0px',
        minWidth: isSidePanelOpen ? '300px' : '0px',
        opacity: isSidePanelOpen ? 1 : 0,
        overflow: 'hidden',
        borderRadius: '0px!important',
        transition: 'all 0.3s ease',
        display: 'flex',
        flexDirection: 'column',
        backgroundColor: '#fff',
        borderLeft: '1px solid #E0E0E0!important',
    }),
    sidePanelHeader: {
        p: '12px',
        display: 'flex',
        alignItems: 'center',
        gap: '2.5px',
        borderBottom: '1px solid #E0E0E0',
    },
    backButtonContainer: {
        display: 'flex',
        alignItems: 'center',
        cursor: 'pointer',
        color: '#006CDD',
    },
    sidePanelTitle: {
        fontSize: '17px',
        fontWeight: 600,
        color: '#212121',
    },
    appointmentList: {
        flex: 1,
        overflowY: 'auto',
        p: '0 12px',
        display: 'flex',
        flexDirection: 'column',
        gap: 1.5,
        maxHeight: '400px',
        '&::-webkit-scrollbar': {
            width: '4px',
        },
    },
    appointmentCard: {
        p: 1,
        borderRadius: '8px!important',
        backgroundColor: '#FFF',
        border: '1px solid rgba(0, 0, 0, 0.10)',
    },
    cardRowBetween: { display: 'flex', alignItems: 'center', justifyContent: 'space-between' },
    cardItem: { display: 'flex', alignItems: 'center', gap: 1 },
    cardItemSmallGap: { display: 'flex', alignItems: 'center', justifyContent: 'end', gap: 0.5, minWidth: '90px' },
    cardText: {
        fontSize: '14px',
        fontWeight: 400,
        lineHeight: '130%',
        letterSpacing: '-0.28px',
    },
};

const CustomDateTimePicker = ({
    open,
    onClose,
    value,
    onChange,
    minDate,
    maxDate,
    shouldDisableDate,
    timeSlotInterval = 30, // minutes between time slots
    onSaveSuccess, // Callback when user successfully saves from date picker
    shopId, // Shop ID passed from parent
}) => {
    // Store temporary selections (not committed until Save)
    const [tempSelectedDate, setTempSelectedDate] = useState(null);
    const [tempSelectedTime, setTempSelectedTime] = useState(null);
    const [currentMonth, setCurrentMonth] = useState(dayjs());
    const [monthMenuAnchor, setMonthMenuAnchor] = useState(null);
    const [yearMenuAnchor, setYearMenuAnchor] = useState(null);
    const [hoveredTimeSlot, setHoveredTimeSlot] = useState(null);
    const [anchorEl, setAnchorEl] = useState(null);
    const [tooltipColor, setTooltipColor] = useState('#007AFF');
    const [isSidePanelOpen, setIsSidePanelOpen] = useState(false);
    const [hoveredAppointmentCount, setHoveredAppointmentCount] = useState(0);
    const [openOutsideBusinessHoursDialog, setOpenOutsideBusinessHoursDialog] = useState(false);
    const [selectedSlot, setSelectedSlot] = useState(null); // Store { slotId, date, timeLabel }
    const hoverTimeoutRef = useRef(null);
    const timePickerRef = useRef(null);
    const previousMonthRef = useRef(null); // Track previous month to detect changes
    const isInitialLoadRef = useRef(true); // Track if this is initial load

    // Extract year and month for available dates API
    const queryYear = useMemo(() => currentMonth.year(), [currentMonth]);
    const currentMonthNumber = useMemo(() => currentMonth.month() + 1, [currentMonth]);

    const SHOP_ID = JSON.parse(localStorage.getItem('apex-saas_details'))?._id;

    // Get available dates for the current month/year
    const availableDatesQuery = useGetAvailableDates(
        { shopId: shopId, year: queryYear.toString(), month: currentMonthNumber.toString(), includeAppointmentCount: true },
        { enabled: open && !!queryYear && !!currentMonthNumber && !!shopId }
    );

    // Process available dates to create a Set of available date strings (YYYY-MM-DD format)
    // Only dates with isAvailable: true are included in the Set
    // Also create a Map of appointment counts for each date
    // Also find first available date in current month when month changes (not on initial load)
    const availableDatesSet = useMemo(() => {
        if (availableDatesQuery.isSuccess && availableDatesQuery.data && Array.isArray(availableDatesQuery.data)) {
            const datesSet = new Set(
                availableDatesQuery.data.filter((dateObj) => dateObj.isAvailable).map((dateObj) => dayjs(dateObj.date).format('YYYY-MM-DD'))
            );

            // Only auto-select first available date when month changes (not on initial load)
            const currentMonthKey = `${currentMonth.year()}-${currentMonth.month()}`;
            const monthChanged = previousMonthRef.current !== null && previousMonthRef.current !== currentMonthKey;

            if (monthChanged && !isInitialLoadRef.current && datesSet.size > 0) {
                // Check if current selected date is in the current month
                const selectedDateInCurrentMonth =
                    tempSelectedDate && tempSelectedDate.month() === currentMonth.month() && tempSelectedDate.year() === currentMonth.year();

                // Only auto-select if selected date is not in current month
                if (!selectedDateInCurrentMonth) {
                    const daysInMonth = currentMonth.daysInMonth();
                    for (let day = 1; day <= daysInMonth; day++) {
                        const date = currentMonth.date(day);
                        const dateStr = date.format('YYYY-MM-DD');
                        if (datesSet.has(dateStr) && !date.isBefore(dayjs(), 'day')) {
                            if (!minDate || !date.isBefore(dayjs(minDate), 'day')) {
                                if (!maxDate || !date.isAfter(dayjs(maxDate), 'day')) {
                                    if (!shouldDisableDate || !shouldDisableDate(date.toDate())) {
                                        setTempSelectedDate(date);
                                        setTempSelectedTime(null);
                                        break;
                                    }
                                }
                            }
                        }
                    }
                }
            }

            // Update previous month ref
            previousMonthRef.current = currentMonthKey;

            return datesSet;
        }
        return new Set();
    }, [availableDatesQuery.isSuccess, availableDatesQuery.data, currentMonth, minDate, maxDate, shouldDisableDate, tempSelectedDate]);

    // Create a Map of appointment counts for each date (YYYY-MM-DD format)
    const appointmentCountMap = useMemo(() => {
        const countMap = new Map();
        if (availableDatesQuery.isSuccess && availableDatesQuery.data && Array.isArray(availableDatesQuery.data)) {
            availableDatesQuery.data.forEach((dateObj) => {
                const dateStr = dayjs(dateObj.date).format('YYYY-MM-DD');
                const appointmentCount = dateObj.appointmentCount;
                // Only store if appointmentCount exists and is greater than 0
                if (appointmentCount != null && appointmentCount > 0) {
                    countMap.set(dateStr, appointmentCount);
                }
            });
        }
        return countMap;
    }, [availableDatesQuery.isSuccess, availableDatesQuery.data]);

    // Check if selected date is available (isAvailable: true)
    const isSelectedDateAvailable = useMemo(() => {
        if (!tempSelectedDate || !availableDatesQuery.isSuccess || availableDatesSet.size === 0) return false;
        const dateStr = tempSelectedDate.format('YYYY-MM-DD');
        return availableDatesSet.has(dateStr);
    }, [tempSelectedDate, availableDatesQuery.isSuccess, availableDatesSet]);

    const slotsQuery = useGetSlotsWithDisabled(
        {
            shopId: shopId,
            date: tempSelectedDate ? dayjs(tempSelectedDate).format('YYYY-MM-DD') : null,
            includeAppointmentCount: true,
        },
        { enabled: !!tempSelectedDate && isSelectedDateAvailable }
    );

    const appointmentsQuery = useGetAppointmentsBySlot(
        {
            shopId: shopId,
            date: selectedSlot?.date || null,
        },
        { enabled: isSidePanelOpen }
    );

    //Slot to show the start time and endtime of the shop logic
    // Process slots from API
    const processedSlotsFull = useMemo(() => {
        // Don't show slots if date is not available (isAvailable: false)
        if (!tempSelectedDate || !isSelectedDateAvailable) {
            return [];
        }
        if (!slotsQuery?.data || !Array.isArray(slotsQuery.data) || availableDatesQuery.isLoading || slotsQuery.isLoading) {
            return [];
        }

        const timeSlots = slotsQuery.data;
        const now = new Date();
        const selectedDateStr = tempSelectedDate.format('YYYY-MM-DD');
        const todayStr = dayjs().format('YYYY-MM-DD');
        const isToday = selectedDateStr === todayStr;

        return timeSlots.map((slot) => {
            const startDateTime = dayjs(slot.startDateTime);
            const timeLabel = startDateTime.format('h:mm A');
            const endTimeLabel = dayjs(slot.endDateTime).format('h:mm A');
            return {
                timeLabel,
                endTimeLabel,
                fullSlot: slot,
                isManuallyDisabled: !slot.availability,
                appointmentCount: slot.appointmentCount,
            };
        });
    }, [slotsQuery?.data, tempSelectedDate, availableDatesQuery.isLoading, slotsQuery.isLoading, isSelectedDateAvailable]);

    // Process slots from API to show the time slot
    const processedSlots = useMemo(() => {
        // Don't show slots if date is not available (isAvailable: false)
        if (!tempSelectedDate || !isSelectedDateAvailable) {
            return [];
        }
        if (!slotsQuery?.data || !Array.isArray(slotsQuery.data) || availableDatesQuery.isLoading || slotsQuery.isLoading) {
            return [];
        }

        const timeSlots = slotsQuery.data;
        const now = new Date();
        const selectedDateStr = tempSelectedDate.format('YYYY-MM-DD');
        const todayStr = dayjs().format('YYYY-MM-DD');
        const isToday = selectedDateStr === todayStr;

        return timeSlots
            .filter((slot) => {
                // Filter out past slots only for display (if selected date is today)
                if (isToday) {
                    const startDateTime = dayjs(slot.startDateTime);
                    const slotTime = startDateTime.format('HH:mm');
                    const combinedDateTimeStr = `${selectedDateStr} ${slotTime}`;
                    const combinedDateTime = dayjs(combinedDateTimeStr, 'YYYY-MM-DD HH:mm').toDate();
                    return combinedDateTime > now;
                }
                return true;
            })
            .map((slot) => {
                const startDateTime = dayjs(slot.startDateTime);
                const timeLabel = startDateTime.format('h:mm A');
                const endTimeLabel = dayjs(slot.endDateTime).format('h:mm A');
                return {
                    timeLabel,
                    endTimeLabel,
                    fullSlot: slot,
                    isManuallyDisabled: !slot.availability,
                    appointmentCount: slot.appointmentCount,
                };
            });
    }, [slotsQuery?.data, tempSelectedDate, availableDatesQuery.isLoading, slotsQuery.isLoading, isSelectedDateAvailable]);

    // Get business hours info for dialog message
    const businessHoursInfo = useMemo(() => {
        const selectedTime = tempSelectedTime ? tempSelectedTime.format('h:mm A') : '';
        const businessDay = tempSelectedDate ? tempSelectedDate.format('dddd') : ''; // e.g., "Monday", "Tuesday"
        const openTime = processedSlotsFull.length > 0 ? processedSlotsFull[0]?.timeLabel : '';
        const closeTime = processedSlotsFull.length > 0 ? processedSlotsFull[processedSlotsFull.length - 1]?.endTimeLabel : '';

        return {
            selectedTime,
            businessDay,
            openTime,
            closeTime,
        };
    }, [tempSelectedTime, tempSelectedDate, processedSlotsFull]);

    // Get days in month
    const getDaysInMonth = () => {
        const year = currentMonth.year();
        const month = currentMonth.month();
        const firstDay = dayjs(`${year}-${month + 1}-01`);
        const daysInMonth = firstDay.daysInMonth();
        const startDayOfWeek = firstDay.day();

        const days = [];
        for (let i = 0; i < startDayOfWeek; i++) {
            days.push(null);
        }
        for (let day = 1; day <= daysInMonth; day++) {
            days.push(day);
        }
        return days;
    };

    const days = getDaysInMonth();
    const weekDays = ['SUN', 'MON', 'TUE', 'WED', 'THU', 'FRI', 'SAT'];

    // Check if date is disabled
    const isDateDisabled = (day) => {
        if (!day) return true;
        const date = currentMonth.date(day);
        if (date.isBefore(dayjs(), 'day')) return true;
        if (minDate && date.isBefore(dayjs(minDate), 'day')) return true;
        if (maxDate && date.isAfter(dayjs(maxDate), 'day')) return true;
        if (shouldDisableDate && shouldDisableDate(date.toDate())) return true;
        return false;
    };

    // Check if date is selected
    const isDateSelected = (day) => {
        if (!day || !tempSelectedDate) return false;
        return tempSelectedDate.date() === day && tempSelectedDate.month() === currentMonth.month() && tempSelectedDate.year() === currentMonth.year();
    };

    // Handle date selection (temporary)
    const handleDateSelect = (day) => {
        if (!day || isDateDisabled(day)) return;
        const newDate = currentMonth.date(day);
        const formattedDate = newDate.format('YYYY-MM-DD');
        const isAvailable = availableDatesSet.has(formattedDate);

        // Force a state update even if the date is the same, to trigger refetch if needed
        // We can do this by setting a timestamp or just ensuring the object reference is new/different enough if we depend on it
        // But react-query depends on the queryKey.
        // Let's rely on the queryKey including the date string.
        setTempSelectedDate(newDate);

        // Close side panel when date changes
        if (isSidePanelOpen) {
            handleCloseSidePanel();
        }

        // If user selects a date that is NOT available (off day), set current time and focus on the time picker input
        // availableDatesQuery must be successful to trust availableDatesSet.
        // If not successful/loaded, we assume available (or normal behavior).
        if (availableDatesQuery.isSuccess && !isAvailable) {
            // setTempSelectedTime(dayjs());
            setTimeout(() => {
                if (timePickerRef.current) {
                    timePickerRef.current.focus();
                }
            }, 100);
        }
    };

    // Handle time selection (temporary)
    const handleTimeSelect = (timeString) => {
        const [time, period] = timeString.split(' ');
        const [hours, minutes] = time.split(':');
        let hour = parseInt(hours);
        if (period === 'PM' && hour !== 12) hour += 12;
        if (period === 'AM' && hour === 12) hour = 0;

        const newTime = dayjs()?.hour(hour)?.minute(parseInt(minutes))?.second(0);
        setTempSelectedTime(newTime);
    };

    // Check if time is selected
    const isTimeSelected = (timeString) => {
        if (!tempSelectedTime) return false;
        const [time, period] = timeString.split(' ');
        const [hours, minutes] = time.split(':');
        let hour = parseInt(hours);
        if (period === 'PM' && hour !== 12) hour += 12;
        if (period === 'AM' && hour === 12) hour = 0;
        return tempSelectedTime?.hour() === hour && tempSelectedTime?.minute() === parseInt(minutes);
    };

    // Handle Save button
    const handleSave = () => {
        if (tempSelectedDate && tempSelectedTime) {
            // Check if selected date is not available (isAvailable: false)
            if (!isSelectedDateAvailable) {
                // Open the dialog for unavailable dates
                setOpenOutsideBusinessHoursDialog(true);
                return;
            }

            // Check if selected time is within business hours
            if (!isTimeWithinBusinessHours(tempSelectedTime, processedSlotsFull)) {
                // Open the dialog for times outside business hours
                setOpenOutsideBusinessHoursDialog(true);
                return;
            }

            // If date is available and time is within business hours, proceed with normal save
            const combinedDateTime = tempSelectedDate?.hour(tempSelectedTime?.hour()).minute(tempSelectedTime?.minute()).second(0).millisecond(0);
            onChange(combinedDateTime);
            // Notify parent that date picker was used and saved successfully
            if (onSaveSuccess) {
                onSaveSuccess();
            }
            handleCloseSidePanel();
            onClose();
        }
    };

    // Handle Continue Anyway from dialog
    const handleContinueAnyway = () => {
        if (tempSelectedDate && tempSelectedTime) {
            const combinedDateTime = tempSelectedDate?.hour(tempSelectedTime?.hour()).minute(tempSelectedTime?.minute()).second(0).millisecond(0);
            onChange(combinedDateTime);
            // Notify parent that date picker was used and saved successfully (even if outside business hours)
            if (onSaveSuccess) {
                onSaveSuccess();
            }
            setOpenOutsideBusinessHoursDialog(false);
            onClose();
        }
    };

    // Handle Cancel button
    const handleCancel = () => {
        // Close side panel if open
        if (isSidePanelOpen) {
            handleCloseSidePanel();
        }
        // Revert to original value
        if (value && dayjs(value).isValid()) {
            const dateValue = dayjs(value);
            setTempSelectedDate(dateValue);
            setTempSelectedTime(dateValue);
            setCurrentMonth(dateValue);
        }
        onClose();
    };

    // Navigate months
    const handlePrevMonth = () => {
        setCurrentMonth((prev) => prev.subtract(1, 'month'));
    };

    const handleNextMonth = () => {
        setCurrentMonth((prev) => prev.add(1, 'month'));
    };

    // Month/Year picker handlers
    const handleMonthClick = (event) => {
        setMonthMenuAnchor(event.currentTarget);
    };

    const handleMonthClose = () => {
        setMonthMenuAnchor(null);
    };

    const handleYearClick = (event) => {
        setYearMenuAnchor(event.currentTarget);
    };

    const handleYearClose = () => {
        setYearMenuAnchor(null);
    };

    const handleMonthSelect = (monthIndex) => {
        setCurrentMonth((prev) => prev.month(monthIndex));
        handleMonthClose();
    };

    const handleYearSelect = (year) => {
        setCurrentMonth((prev) => prev.year(year));
        handleYearClose();
    };

    const handleSlotHover = (event, time, isRed, appointmentCount) => {
        // Clear any existing timeout
        if (hoverTimeoutRef.current) {
            clearTimeout(hoverTimeoutRef.current);
            hoverTimeoutRef.current = null;
        }

        // If slot has no data, clear tooltip immediately and return
        if (!isRed && (!appointmentCount || appointmentCount <= 0)) {
            setHoveredTimeSlot(null);
            setAnchorEl(null);
            return;
        }

        // Show tooltip for slot with data
        setTooltipColor(isRed ? '#D32F2F' : '#007AFF');
        setHoveredTimeSlot(time);
        setHoveredAppointmentCount(appointmentCount || 0);
        setAnchorEl(event.currentTarget);
    };

    const handleSlotLeave = () => {
        // Clear timeout if exists
        if (hoverTimeoutRef.current) {
            clearTimeout(hoverTimeoutRef.current);
        }
        // Use small delay to allow moving from slot to tooltip without flickering
        hoverTimeoutRef.current = setTimeout(() => {
            setHoveredTimeSlot(null);
            setAnchorEl(null);
            hoverTimeoutRef.current = null;
        }, 200);
    };

    const handleTooltipEnter = () => {
        // Clear timeout to keep tooltip visible when mouse enters tooltip
        if (hoverTimeoutRef.current) {
            clearTimeout(hoverTimeoutRef.current);
            hoverTimeoutRef.current = null;
        }
    };

    const handleTooltipLeave = () => {
        // Clear timeout if exists
        if (hoverTimeoutRef.current) {
            clearTimeout(hoverTimeoutRef.current);
        }
        // Hide tooltip immediately when leaving tooltip
        setHoveredTimeSlot(null);
        setAnchorEl(null);
        hoverTimeoutRef.current = null;
    };

    const handleOpenSidePanel = (slotItem) => {
        // Store selected slot info for API call
        if (slotItem && slotItem.fullSlot) {
            const slotId = slotItem.fullSlot._id || slotItem.fullSlot.slotId;
            setSelectedSlot({
                slotId,
                date: tempSelectedDate ? dayjs(tempSelectedDate).format('YYYY-MM-DD') : null,
                timeLabel: slotItem.timeLabel,
            });
        }
        setIsSidePanelOpen(true);
        // Clear hover states to hide tooltip when panel opens
        if (hoverTimeoutRef.current) clearTimeout(hoverTimeoutRef.current);
        setHoveredTimeSlot(null);
        setAnchorEl(null);
    };

    const handleCloseSidePanel = () => {
        setIsSidePanelOpen(false);
        setSelectedSlot(null); // Clear selected slot when panel closes
    };

    // Generate months and years
    const months = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
    const currentYear = currentMonth.year();
    const years = [];
    for (let i = currentYear - 5; i <= currentYear + 5; i++) {
        years.push(i);
    }

    // Initialize from value prop when modal opens
    useEffect(() => {
        if (open) {
            isInitialLoadRef.current = true;
            if (value && dayjs(value).isValid()) {
                const dateValue = dayjs(value);
                setTempSelectedDate(dateValue);
                setTempSelectedTime(dateValue);
                setCurrentMonth(dateValue);
                previousMonthRef.current = `${dateValue.year()}-${dateValue.month()}`;
            } else {
                const today = dayjs();
                setTempSelectedDate(today);
                setTempSelectedTime(dayjs()); // Show current time when opening without a value
                setCurrentMonth(today);
                previousMonthRef.current = `${today.year()}-${today.month()}`;
            }
            // Mark initial load as complete after a short delay to allow useMemo to run
            setTimeout(() => {
                isInitialLoadRef.current = false;
            }, 100);
        } else {
            if (!tempSelectedDate) {
                const dateValue = dayjs(value);
                setTempSelectedDate(dateValue);
            }
            // Reset on close
            isInitialLoadRef.current = true;
            previousMonthRef.current = null;
        }
    }, [value, open]);

    return (
        <>
            <Dialog
                open={open}
                onClose={(event, reason) => {
                    // Close side panel if open
                    if (isSidePanelOpen) {
                        handleCloseSidePanel();
                    }
                    // Only allow closing via ESC key, not backdrop click
                    if (reason !== 'backdropClick') {
                        onClose();
                    }
                }}
                maxWidth={false}
                PaperProps={{
                    sx: styles.dialogPaper(isSidePanelOpen),
                }}
            >
                <DialogContent sx={styles.dialogContent}>
                    <Box sx={styles.container}>
                        {/* LEFT SECTION (Calendar + TimeSlots + Footer) */}
                        <Box sx={styles.leftSection(isSidePanelOpen)}>
                            {/* Upper Row: Calendar + Time Slots */}
                            <Box sx={styles.upperRow}>
                                {/* Calendar */}
                                <Box sx={styles.calendarSection}>
                                    {/* Calendar Header */}
                                    <Box sx={styles.calendarHeader}>
                                        <IconButton onClick={handlePrevMonth} size="small" sx={styles.navButton}>
                                            <ChevronLeft sx={{ fontSize: '28px' }} />
                                        </IconButton>
                                        <Box sx={styles.headerTextGroup}>
                                            <Typography onClick={handleMonthClick} sx={styles.monthText}>
                                                {currentMonth.format('MMMM YYYY')}
                                            </Typography>

                                            <IconButton onClick={handleYearClick} size="small" sx={styles.yearArrowBtn}>
                                                <KeyboardArrowDown sx={{ fontSize: '24px' }} />
                                            </IconButton>
                                        </Box>
                                        {/* Month Menu */}
                                        <Menu
                                            anchorEl={monthMenuAnchor}
                                            open={Boolean(monthMenuAnchor)}
                                            onClose={handleMonthClose}
                                            PaperProps={{ sx: styles.menu }}
                                        >
                                            {months.map((month, index) => (
                                                <MenuItem
                                                    key={month}
                                                    onClick={() => handleMonthSelect(index)}
                                                    selected={currentMonth.month() === index}
                                                    sx={styles.menuItem}
                                                >
                                                    {month}
                                                </MenuItem>
                                            ))}
                                        </Menu>
                                        {/* Year Menu */}
                                        <Menu
                                            anchorEl={yearMenuAnchor}
                                            open={Boolean(yearMenuAnchor)}
                                            onClose={handleYearClose}
                                            PaperProps={{ sx: styles.menu }}
                                        >
                                            {years.map((year) => (
                                                <MenuItem
                                                    key={year}
                                                    onClick={() => handleYearSelect(year)}
                                                    selected={currentMonth.year() === year}
                                                    sx={styles.menuItem}
                                                >
                                                    {year}
                                                </MenuItem>
                                            ))}
                                        </Menu>
                                        <IconButton onClick={handleNextMonth} size="small" sx={styles.navButton}>
                                            <ChevronRight sx={{ fontSize: '28px' }} />
                                        </IconButton>
                                    </Box>
                                    {/* Week Days Header */}
                                    <Grid container spacing={0} sx={styles.weekDayContainer}>
                                        {weekDays.map((day) => (
                                            <Grid item xs={12 / 7} key={day}>
                                                <Typography sx={styles.weekDayText}>{day}</Typography>
                                            </Grid>
                                        ))}
                                    </Grid>

                                    {/* Calendar Days */}
                                    {availableDatesQuery.isLoading || availableDatesQuery.isFetching ? (
                                        <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '200px' }}>
                                            <CircularProgress />
                                        </Box>
                                    ) : (
                                        <Grid container spacing={0}>
                                            {days.map((day, index) => {
                                                const disabled = isDateDisabled(day);
                                                const selected = isDateSelected(day);
                                                const isToday =
                                                    day && dayjs().date(day).month(currentMonth.month()).year(currentMonth.year()).isSame(dayjs(), 'day');

                                                // Determine if the day is "off" (not in available dates)
                                                // Only consider this if we have data loaded. If loading, don't show as off.
                                                let isOff = false;
                                                let appointmentCount = 0;
                                                if (day && availableDatesQuery.isSuccess) {
                                                    const dateStr = currentMonth.date(day).format('YYYY-MM-DD');
                                                    isOff = !availableDatesSet.has(dateStr);
                                                    appointmentCount = appointmentCountMap.get(dateStr) || 0;
                                                }

                                                return (
                                                    <Grid item xs={12 / 7} key={index} sx={styles.dayGridItem}>
                                                        <Box
                                                            onClick={() => !disabled && handleDateSelect(day)}
                                                            sx={styles.dayButton(disabled, selected, isToday, isOff)}
                                                        >
                                                            {day}
                                                            {appointmentCount > 0 && <Box sx={styles.dayDot(selected)} />}
                                                        </Box>
                                                    </Grid>
                                                );
                                            })}
                                        </Grid>
                                    )}
                                </Box>

                                {/* Time Slots */}
                                <Box sx={styles.timeListContainer}>
                                    {!tempSelectedDate ||
                                    (isSelectedDateAvailable && (slotsQuery.isPending || slotsQuery.isFetching || slotsQuery.isLoading)) ||
                                    availableDatesQuery.isLoading ? (
                                        <Box
                                            sx={{
                                                display: 'flex',
                                                justifyContent: 'center',
                                                alignItems: 'center',
                                                height: '100%',
                                                width: '100%',
                                                minHeight: '200px',
                                            }}
                                        >
                                            <CircularProgress />
                                        </Box>
                                    ) : (
                                        <Stack spacing={1} sx={styles.timeStack}>
                                            {processedSlots.length > 0 ? (
                                                processedSlots.map((slotItem) => {
                                                    const { timeLabel, isManuallyDisabled, appointmentCount } = slotItem;
                                                    const selected = isTimeSelected(timeLabel);

                                                    return (
                                                        <Button
                                                            key={timeLabel}
                                                            onMouseEnter={(e) => handleSlotHover(e, timeLabel, isManuallyDisabled, appointmentCount)}
                                                            onMouseLeave={handleSlotLeave}
                                                            onClick={() => handleTimeSelect(timeLabel)}
                                                            variant={selected ? 'contained' : 'outlined'}
                                                            sx={styles.timeSlotButton(selected, isManuallyDisabled)}
                                                        >
                                                            {timeLabel}
                                                        </Button>
                                                    );
                                                })
                                            ) : (
                                                <Typography sx={{ p: 2, textAlign: 'center', color: '#757575', fontSize: '14px' }}>
                                                    No time slots available.
                                                </Typography>
                                            )}
                                        </Stack>
                                    )}
                                    <Popper
                                        open={Boolean(anchorEl)}
                                        anchorEl={anchorEl}
                                        placement="right"
                                        modifiers={styles.popperModifiers}
                                        sx={{ zIndex: 1500 }}
                                        onMouseEnter={handleTooltipEnter}
                                        onMouseLeave={handleTooltipLeave}
                                    >
                                        <Box sx={styles.tooltipContainer}>
                                            {/* Connector Line */}
                                            <Box sx={styles.tooltipConnector(tooltipColor)}>
                                                <Box sx={{ ...styles.tooltipDot(tooltipColor), marginLeft: '-2.5px' }} />
                                                <Box sx={{ ...styles.tooltipDot(tooltipColor), marginRight: '-2.5px' }} />
                                            </Box>
                                            {tooltipColor === '#D32F2F' ? (
                                                <Paper
                                                    elevation={3}
                                                    sx={{
                                                        ...styles.tooltipPaper,
                                                        backgroundColor: '#D32F2F',
                                                        border: '1px solid #D32F2F',
                                                        justifyContent: 'center',
                                                        cursor: 'default',
                                                    }}
                                                >
                                                    <Typography sx={{ ...styles.tooltipText, color: '#FFF' }}>Manually disabled</Typography>
                                                </Paper>
                                            ) : (
                                                <Paper
                                                    elevation={3}
                                                    onClick={() => {
                                                        // Find the slot item from processedSlots
                                                        const slotItem = processedSlots.find((s) => s.timeLabel === hoveredTimeSlot);
                                                        handleOpenSidePanel(slotItem);
                                                    }}
                                                    sx={styles.tooltipPaper}
                                                >
                                                    <Box sx={styles.tooltipCountBox}>{hoveredAppointmentCount}</Box>
                                                    <Typography sx={styles.tooltipText}>{hoveredAppointmentCount === 1 ? 'Appt' : 'Appts'}</Typography>
                                                    <ChevronRight sx={{ fontSize: '25px', color: '#007AFF' }} />
                                                </Paper>
                                            )}
                                        </Box>
                                    </Popper>
                                </Box>
                            </Box>

                            {/* Footer */}
                            <Box sx={styles.footerContainer}>
                                {/* TIME ROW */}
                                <Box sx={styles.timeRow}>
                                    <Typography sx={styles.timeLabel}>Time</Typography>

                                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                                        <TimePicker
                                            value={tempSelectedTime}
                                            onChange={(newValue) => {
                                                if (newValue) {
                                                    setTempSelectedTime(newValue);
                                                }
                                            }}
                                            sx={styles.timePickerSx}
                                            slotProps={{
                                                textField: {
                                                    variant: 'outlined',
                                                    placeholder: 'Select time',
                                                    inputRef: timePickerRef,
                                                },
                                            }}
                                        />
                                    </LocalizationProvider>
                                </Box>

                                {/* BUTTONS */}
                                <Box sx={styles.buttonsRow}>
                                    <Button variant="outlined" onClick={handleCancel}>
                                        Cancel
                                    </Button>

                                    <Button variant="contained" onClick={handleSave} disabled={!tempSelectedDate || !tempSelectedTime}>
                                        Save
                                    </Button>
                                </Box>
                            </Box>
                        </Box>

                        {/* Side Panel */}
                        <Box sx={styles.sidePanel(isSidePanelOpen)}>
                            {/* Side Panel Header */}
                            <Box sx={styles.sidePanelHeader}>
                                <Box onClick={handleCloseSidePanel} sx={styles.backButtonContainer}>
                                    <ChevronLeft sx={{ fontSize: '25px' }} />
                                    <Typography sx={styles.sidePanelTitle}>Appointments</Typography>
                                </Box>
                            </Box>

                            {/* Appointment List */}
                            <Box sx={styles.appointmentList}>
                                {appointmentsQuery.isLoading || appointmentsQuery.isFetching ? (
                                    <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: 'calc(100% - 50px)' }}>
                                        <CircularProgress />
                                    </Box>
                                ) : appointmentsQuery.data && appointmentsQuery.data.length > 0 ? (
                                    appointmentsQuery.data.map((appointment) => {
                                        const customerName = `${appointment.customer?.firstName || ''} ${appointment.customer?.lastName || ''}`.trim();
                                        const vehicleInfo = appointment.vehicle
                                            ? `${appointment.vehicle.year || ''} ${appointment.vehicle.vehicleMake?.name || ''} ${appointment.vehicle.vehicleModel?.name || ''}`.trim()
                                            : 'N/A';
                                        const serviceText =
                                            appointment.serviceCount > 1
                                                ? `${appointment.serviceCount} Services`
                                                : appointment.services?.[0]?.name || 'Service';
                                        const time = appointment.dropOffTime ? dayjs(appointment.dropOffTime).format('h:mm A') : 'N/A';

                                        return (
                                            <Paper key={appointment.appointmentId} elevation={0} sx={styles.appointmentCard}>
                                                <Stack spacing={1}>
                                                    <Box sx={styles.cardRowBetween}>
                                                        <Box sx={styles.cardItem}>
                                                            <UserIcon />
                                                            <Typography sx={styles.cardText}>{customerName || 'N/A'}</Typography>
                                                        </Box>
                                                        <Box sx={styles.cardItemSmallGap}>
                                                            <ClockIcon />
                                                            <Typography sx={styles.cardText}>{time}</Typography>
                                                        </Box>
                                                    </Box>
                                                    <Box sx={styles.cardItem}>
                                                        <CarIcon />
                                                        <Typography sx={styles.cardText}>{vehicleInfo}</Typography>
                                                    </Box>
                                                    <Box sx={styles.cardItem}>
                                                        <ServiceIcon />
                                                        <Typography sx={styles.cardText}>{serviceText}</Typography>
                                                    </Box>
                                                </Stack>
                                            </Paper>
                                        );
                                    })
                                ) : (
                                    <Typography sx={{ p: 2, textAlign: 'center', color: '#757575', fontSize: '14px' }}>No appointments found.</Typography>
                                )}
                            </Box>
                        </Box>
                    </Box>
                </DialogContent>
            </Dialog>

            <CommonDialog
                open={openOutsideBusinessHoursDialog}
                onClose={() => setOpenOutsideBusinessHoursDialog(false)}
                dialogClaassName="commonDialog commonDialog__560"
                dialogTitle={isSelectedDateAvailable ? '⚠️ Outside Drop-Off Availability' : '⚠️ Shop Closed'}
                dialogSubtitle={
                    isSelectedDateAvailable
                        ? `The selected drop-off time (${businessHoursInfo.selectedTime}) is outside the shop's configured drop-off availability (${businessHoursInfo.businessDay} ${businessHoursInfo.openTime} – ${businessHoursInfo.closeTime}).`
                        : `The selected drop-off time (${businessHoursInfo.selectedTime}) is on a day the shop is closed (${businessHoursInfo.businessDay}).`
                }
                dialogSubtitle2={'Would you like to adjust time or continue? '}
                cancelButtonWidth={'143px'}
                cancelButtonVariant={'outlined'}
                cancelButtonText={'adjust time'}
                saveButtonType={'primary'}
                saveButtonVariant={'contained'}
                saveButtonText={'continue anyway'}
                saveButtonWidth={'188px'}
                onSave={handleContinueAnyway}

                // confirmButtonType={'secondary'}
                // confirmButtonText={'continue anyway'}
                // confirmButtonWidth={'188px'}
                // onConfirm={handleContinueAnyway}
            />
        </>
    );
};

export default CustomDateTimePicker;
